import {BOOLEAN, CONST, OBJECT, guard} from '@acng/frontend-rubicon';

import {listen} from '../../core/context/event-bus.js';
import {TIMESTAMP_MS} from '../../core/model/time.js';
import {addPin, removePin} from './cache.js';
import {ALOHA_PARTNER} from '../../userPool/model/aloha-partner.js';

listen('pin', (data) => {
  ASSERT: guard(data, EVENTBUS_PIN);
  const id = `${data.partner.id}`;

  if (data.status) {
    addPin(id);
  } else {
    removePin(id);
  }
});

const EVENTBUS_PIN = /* @__PURE__ */ OBJECT({
  type: /* @__PURE__ */ CONST('pin'),
  partner: ALOHA_PARTNER,
  status: BOOLEAN,
  timestamp_ms: TIMESTAMP_MS,
});
